class YoastFAQ {
	init() {
		const self = this;
		self.addAccordion();
	}

	addAccordion() {
		const block = jQuery('.wp-block-yoast-faq-block');
		if (typeof block !== 'undefined') {
			jQuery('.schema-faq-question').click(function () {
				if (jQuery(this).siblings('.schema-faq-answer').is(':visible')) {
					jQuery(this).removeClass('faq-q-open');
					jQuery(this)
						.siblings('.schema-faq-answer')
						.removeClass('faq-a-open')
						.slideUp();
				} else {
					jQuery(this).addClass('faq-q-open');
					jQuery(this)
						.siblings('.schema-faq-answer')
						.addClass('faq-a-open')
						.slideDown();
				}
			});
		}
	}
}

const instance = new YoastFAQ();
export default instance;
